import { render } from "./BomHeaderPartNumber.vue?vue&type=template&id=0992737c"
import script from "./BomHeaderPartNumber.vue?vue&type=script&lang=js"
export * from "./BomHeaderPartNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__